export default {
  title_select: "Select an option to set a date for closing order",
  label_close: "Close with current date and time",
  label_set: "I want to set the date and time",
  cancel: "Cancel",
  accept: "Accept",
  btn_confirm: "Yes, I want to close this order",
  title_closing: "Closing Order Verification",
  label_confirm: "Confirm you want to close this order",
  label_closed: "Will be closed on this date:",
  loading: "Loading",
};
